export default "<div class=\"navbar-wrap\">\n  <ng-content></ng-content>\n</div>\n"